import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import ArrowToolTip from '../../common/ArrowToolTip';
import IconButton from 'material-ui/IconButton';
import SettingIcon from '../../Icons/SettingIcon';
import DropdownMenu from '../../common/DropdownMenu';

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },

  iconButton: {
    color: '#71737B',
    padding: 0,
    width: '32px',
    minWidth: '32px',
    height: '32px',
    minHeight: '32px',
    marginLeft: '10px',
  },
});

class DateRange extends React.Component {
  render() {
    const { classes, isDemo } = this.props;

    return (
      <div className={classes.root}>
        <ArrowToolTip text="期間を絞り込む">
          <div>
            {isDemo ?
              <IconButton
                className={classes.iconButton} onClick={this.props.togglePlanDialog}
              >
                <SettingIcon color='#71737B' />
              </IconButton>
              :
              <DropdownMenu
                menuItems={
                  Object.values(this.props.dateRanges).map(item => {
                    return {
                      name: item.text,
                      func: () => this.props.handleSelectDate(item)
                    }
                  })
                }
                classes={{
                  btn: classes.iconButton,
                }}
                popperPlacement="bottom-end"
                selected={this.props.dateSelected.text}
              >
                <SettingIcon color='#71737B' />
              </DropdownMenu>}
          </div>
        </ArrowToolTip>
      </div>
    )
  }
}

DateRange.propTypes = {
  classes: PropTypes.object.isRequired,
  isDemo: PropTypes.bool,
  dateSelected: PropTypes.object.isRequired,
  togglePlanDialog: PropTypes.func.isRequired,
  handleSelectDate: PropTypes.func.isRequired,
  dateRanges: PropTypes.object,
};

export default withStyles(styles)(DateRange);


// WEBPACK FOOTER //
// ./src/components/OrderDashboard/controls/DateRange.jsx